export default __webpack_public_path__ + "static/media/angel-one.df4fbb60.svg";